import React from 'react';
import { HVAConversationProvider } from './HVARealEstateConversationContext';
import HVARealEstateModalContent from './HVARealEstateModalContent';
import { HVARealEstateModalProps } from './HVARealEstateData';

const HVARealEstateModal: React.FC<HVARealEstateModalProps> = props => {
  return (
    <HVAConversationProvider>
      <HVARealEstateModalContent {...props} />
    </HVAConversationProvider>
  );
};

export default HVARealEstateModal;
